import React from 'react';
import classnames from 'classnames';
import s from './FeedContent.scss';

export interface Props {
  className?: string;
}

const FeedContent: React.FC<React.PropsWithChildren<Props>> = ({ children, className }) => (
  <div className={classnames(s['root'], className)}>{children}</div>
);
FeedContent.displayName = 'FeedContent';

export default FeedContent;
